import { createFileRoute } from '@tanstack/react-router'
import { CasesList } from 'pages/cases/CasesList'
import { z } from 'zod'

const parseParams = z.object({
  siteID: z.string(),
})

export const Route = createFileRoute('/cases/{-$siteID}/')({
  component: CasesList,
  params: {
    parse: parseParams.parse,
  },
  staticData: {
    title: 'Cases',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
